<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import event from '@/util/event'
import getWebsiteAjax from '@/util/getWebsiteAjax'

export default {
  name: 'App',

  async created() {
    const data = await getWebsiteAjax()
    document.title = data.title
    this.$store.commit('setValue', data)

    event.$on('logout', () => {
      this.$store.commit('logout')
      this.$router.push({ name: 'Login' })
    })
  }
}
</script>

<style>
video {
  outline: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue